import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {OrgService} from '../services/org.service';
import {CDSNode} from '../services/capd.model';
import {CAPDAdminComponent} from "../capd-admin-component/capd-admin.component";

@Component({
  selector: 'mmodal-manager',
  templateUrl: './client-manager.component.html',
})

/**
 * Manages the view of the company-level components of CAPD Admin.
 */
export class ClientManagerComponent implements OnInit, OnDestroy {

  orgRoot: string;
  orgDesc: string = null;
  groupDesc: string = null;
  type = '';
  private sub: any;
  uiVersion: string = 'Classic'

  constructor(
    private _org: OrgService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _adminComponent: CAPDAdminComponent) {
    this._adminComponent.uiChangeEvent.subscribe({
      next: (event) => {
        this.uiVersion = event
      }
    })
  }

  /**
   * Initializes the view by determining if this is a structural customer page or a settings group.
   *
   * @func ngOnInit
   */
  ngOnInit() {
    this.uiVersion = sessionStorage.getItem("uiVersion")
    this.sub = this._route.firstChild.params.subscribe(params => {
      this.orgRoot = params.id;
      if (this.orgRoot.includes('%2B') || this.orgRoot.includes('+')) {
        this.type = 'SettingsGroup';

        let extendedRoot = this.orgRoot.replace('~', '2.16.840.1.113883.3.21');
        let extension = extendedRoot.substr((extendedRoot.indexOf('~') - 1), extendedRoot.length);
        let rootOid = extendedRoot.substr(0, (extendedRoot.indexOf('+')));

        this._org.getGroup(rootOid, extension).then((group: CDSNode) => {
          // avoid stalling UI with error if group doesn't exist in cache yet
          if(group) {
            this.groupDesc = group.description;
          }
        });
      } else {
        this.type = 'Customer';
        this.groupDesc = null;
        //@ts-ignore
        this._org.getOrgInfo(this.orgRoot).then((org: CDSNode) => {this.orgDesc = org.description})
          .catch(() => console.log('No matching organization found for: ' + this.orgRoot));
      }
    });
  }

  /**
   * Disposes of the subscriber when the view is navigated away from.
   *
   * @func ngOnDestroy
   */
  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
